import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/config";
import { useAuth } from "../Context/AuthContext";

export default function RequirePlatformAdmin({ children }) {
  const { user, loading } = useAuth();

  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const check = async () => {
      if (loading) return;

      // not logged in
      if (!user?.uid) {
        if (!cancelled) {
          setAllowed(false);
          setChecking(false);
        }
        return;
      }

      try {
        const snap = await getDoc(doc(db, "users", user.uid));
        const data = snap.data() || {};

        // ✅ choose ONE:
        // Option A: boolean flag
        const ok = data.isPlatformAdmin === true;

        // Option B: role string
        // const ok = data.role === "platform_admin";

        if (!cancelled) {
          setAllowed(ok);
          setChecking(false);
        }
      } catch (e) {
        console.error("RequirePlatformAdmin check failed:", e);
        if (!cancelled) {
          setAllowed(false);
          setChecking(false);
        }
      }
    };

    check();
    return () => {
      cancelled = true;
    };
  }, [user?.uid, loading]);

  if (loading || checking) return null; // or your loader component

  if (!allowed) return <Navigate to="/admin-dashboard" replace />;

  return children;
}
